import Image from "next/image";
import Link from "next/link";

import { buttonVariants } from "@/components/fun-ui/Button";
import { cn } from "@/lib/utils";

type FollowUsItem = {
  qrCode: string;
  label: string;
  account: string;
  icon: string;
  url?: string;
};

export function SiteFollowUsCards({
  className,
  items = [],
}: {
  className?: string;
  items?: FollowUsItem[];
}) {
  return (
    <div className={cn(
      "flex items-center justify-center h-[268px] gap-10 mt-6 flex-wrap",
      className,
    )}>
      {items.map(({
        qrCode,
        label,
        account,
        icon,
        url,
      }) => (
        <div
          key={label}
          className="group cursor-pointer bg-[#F8F9FC] rounded-[12px] flex flex-col items-center justify-center transition-all duration-150 min-w-[250px] h-[84px] hover:h-[268px]"
        >
          <div className="flex items-center justify-center transition-all duration-150 h-0 group-hover:h-[152px] overflow-hidden">
            <div className="flex items-center justify-center w-[140px] h-[140px] rounded-lg mb-[12px] border border-muted-foreground border-solid overflow-hidden">
              <Image className="w-full h-full" src={qrCode} width={130} height={130} alt={label} />
            </div>
          </div>
          <div className="h-[34px] flex items-center">
            <Image className="w-fit h-fit mr-3" src={icon} width={28} height={28} alt={label} />
            <span>{label}</span>
            <span className="hidden group-hover:inline-block">：{account}</span>
          </div>
          {url ? (
            <Link
              href={url}
              target="_blank"
              className={cn(
                buttonVariants({ variant: 'default' }),
                "py-0 rounded-full cursor-pointer",
                "hidden group-hover:flex h-[38px] w-[120px] mt-3",
              )}
            >点击关注</Link>
          ) : null}
        </div>
      ))}
    </div>
  );
}
